import script from "./SideBarItemWithSubMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideBarItemWithSubMenu.vue?vue&type=script&lang=ts&setup=true"

import "./SideBarItemWithSubMenu.vue?vue&type=style&index=0&id=b21b21aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b21b21aa"]])

export default __exports__